import {Injectable} from "@angular/core";
import {UtilsService} from "../../utils/utils.service";
import {Auth2Service} from "../security/auth2.service";
import {Router} from "@angular/router";
import { HttpParams } from "@angular/common/http";
import {HttpService} from "../technique/http.service";
import {GraphQLService} from "../technique/graphql.service";
import {Observable, Subject} from "rxjs";
import {catchError} from "rxjs/operators";
import {PointTeledeclarationEgalimDto} from "../../dtos/egalim/point-teledeclaration-egalim-dto";
import {ObjectDTO} from "../../dtos/object-dto";

@Injectable({
  providedIn: 'root'
})
export class PointTeledeclarationEgalimService {

  private subjectOpenDialogEditionPointTeledeclarationEgalim = new Subject<PointTeledeclarationEgalimDto>();
  openDialogEditionPointTeledeclarationEgalim$ = this.subjectOpenDialogEditionPointTeledeclarationEgalim.asObservable();

  private subjectPointTeledeclarationEgalimSaved = new Subject<PointTeledeclarationEgalimSavedSupplier>();
  pointTeledeclarationEgalimSaved$ = this.subjectPointTeledeclarationEgalimSaved.asObservable();

  constructor(private utils: UtilsService,
              private auth2Svc: Auth2Service,
              private router: Router,
              private httpSvc: HttpService,
              private graphQlSvc: GraphQLService
  ) {
  }

  announceOpenDialogEditionPointTeledeclarationEgalim = (pointTeledeclarationEgalim: PointTeledeclarationEgalimDto) => {
    this.subjectOpenDialogEditionPointTeledeclarationEgalim.next(pointTeledeclarationEgalim);
  };

  announcePointTeledeclarationEgalimSaved = (pointTeledeclarationEgalim: PointTeledeclarationEgalimDto, isUpdate: boolean = false) => {
    this.subjectPointTeledeclarationEgalimSaved.next({isUpdate, pointTeledeclarationEgalim} as PointTeledeclarationEgalimSavedSupplier);
  }


  findAllPointTeledeclarationEgalim = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
          allPointTeledeclarationEGAlim(filters: {
          siteIds: [${this.auth2Svc.utilisateur.sites.map(s => s.id)}],
        }) {
          ${PointTeledeclarationEgalimDto.getAllProperties()}
        }
      }
    `).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  savePointTeledeclarationEgalim = (pointTeledeclarationEgalim: PointTeledeclarationEgalimDto) => {
    return this.httpSvc.post(`dolrest/point-teledeclaration/save`, pointTeledeclarationEgalim).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  deletePointTeledeclarationEgalim = (ids: number[]) => {
    const params: HttpParams = new HttpParams().set('idsToDelete', ids.join(','));
    return this.httpSvc.delete(`dolrest/point-teledeclaration/delete`, params).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  canModify(element: ObjectDTO): boolean {
    if (this.utils.isNullOrEmpty(element?.site?.id) || element.site.id === 0)
      return true;
    return this.auth2Svc.isSiteLocal(element.site.id);
  }


}

export interface PointTeledeclarationEgalimSavedSupplier {
  isUpdate: boolean;
  pointTeledeclarationEgalim: PointTeledeclarationEgalimDto;
}
